export const WORKSPACE_ID_STORAGE_KEY = "ai.supergrow.workspace.id";
export const WORKSPACE_ROLE_STORAGE_KEY = "ai.supergrow.workspace.role";
export const ORG_ID_STORAGE_KEY = "ai.supergrow.org.id";
export const BROWSING_MEMBER_WORKSPACE_KEY = "ai.supergrow.browsing_member_workspace";
export const BROWSING_ORG_ROLE_KEY = "ai.supergrow.browsing_org_role";

export function storeActiveWorkspace(id) {
  localStorage.setItem(WORKSPACE_ID_STORAGE_KEY, id);
}

export function storeRole(role) {
  localStorage.setItem(WORKSPACE_ROLE_STORAGE_KEY, role);
}

export function storeActiveOrg(id) {
  localStorage.setItem(ORG_ID_STORAGE_KEY, id);
}

export function storeBrowsingMemberWorkspace(workspaceName, orgRole) {
  localStorage.setItem(BROWSING_MEMBER_WORKSPACE_KEY, workspaceName);
  if (orgRole) {
    localStorage.setItem(BROWSING_ORG_ROLE_KEY, orgRole);
  }
}

export function getBrowsingMemberWorkspace() {
  return localStorage.getItem(BROWSING_MEMBER_WORKSPACE_KEY);
}

export function getBrowsingOrgRole() {
  return localStorage.getItem(BROWSING_ORG_ROLE_KEY);
}

export function clearBrowsingMemberWorkspace() {
  localStorage.removeItem(BROWSING_MEMBER_WORKSPACE_KEY);
  localStorage.removeItem(BROWSING_ORG_ROLE_KEY);
}

export function getStoredWorkspace() {
  return localStorage.getItem(WORKSPACE_ID_STORAGE_KEY);
}

export function getStoredRole() {
  return localStorage.getItem(WORKSPACE_ROLE_STORAGE_KEY);
}

export function getStoredOrg() {
  return localStorage.getItem(ORG_ID_STORAGE_KEY);
}

export function removeWorkspace() {
  return localStorage.removeItem(WORKSPACE_ID_STORAGE_KEY);
}

export function removeRole() {
  return localStorage.removeItem(WORKSPACE_ROLE_STORAGE_KEY);
}

export function removeOrg() {
  return localStorage.removeItem(ORG_ID_STORAGE_KEY);
}
